import React, { FC, useState } from "react";
import styled, { css } from "styled-components";
import { easeOut, easeIn } from "../styles/atoms";

type option = {
  value: string;
  description?: string;
  imageUrl?: string;
};
interface Props {
  options?: option[];
  selectedDefault?: string;
  minWidth?: number;
  onChange: (value: string) => void;
  isMobile?: boolean;
  isDetail?: boolean;
  multipleRows?: boolean;
  disabled?: boolean;
}
const SelectionFilter: FC<Props> = ({
  onChange,
  options,
  minWidth,
  selectedDefault,
  isMobile,
  isDetail,
  multipleRows,
  disabled,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(
    selectedDefault
  );

  return (
    <Wrapper {...props}>
      {options.map(({ value, description, imageUrl }) => {
        return (
          <Label
            multipleRows={multipleRows}
            isMobile={isMobile}
            isDetail={isDetail}
            key={value}
            active={value === selectedValue}
            minWidth={minWidth}
            onClick={() => {
              setSelectedValue(value);
              onChange(value);
            }}
            title={value}
            disabled={disabled}
          >
            <LabelWrap>
              {!!description && <Description>{description}</Description>}
              <Value>{value}</Value>
            </LabelWrap>
            {!!imageUrl && (
              <ImageWrapper active={value === selectedValue}>
                <img src={imageUrl} className="cover" />
              </ImageWrapper>
            )}
          </Label>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px -10px 0;
`;

const Description = styled.span`
  display: block;
  font-size: 12px;
  margin-bottom: 0.3em;
  color: #818181;
  transition: inherit;
`;

export const Value = styled.span`
  display: block;
  color: #000;
  line-height: 1.2;
  transition: inherit;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const LabelWrap = styled.span`
  max-width: 100%;
`;

const ActiveLabel = css`
  background: #78b833;
  box-shadow: 0px 6px 12px rgba(128, 168, 18, 0.430565);
  ${easeOut};
`;
interface LabelProps {
  active: boolean;
  minWidth?: number;
  isMobile?: boolean;
  isDetail?: boolean;
  multipleRows?: boolean;
  disabled?: boolean;
}
export const Label = styled.label<LabelProps>`
  cursor: pointer;
  background: #f5f5f5;
  border-radius: 10px;
  color: #fff;
  margin: 0 10px 10px 0;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  min-width: ${({ minWidth, multipleRows }) =>
    multipleRows
      ? "calc(33.33% - 10px)"
      : minWidth
      ? `${minWidth}px`
      : undefined};
  overflow: hidden;

  ${({ isMobile, isDetail }) =>
    isMobile
      ? css`
          height: 42px;
          padding: 8px;
        `
      : css`
          padding: ${isDetail ? "10px 12px" : "0.75em 1em"};
          min-height: ${isDetail ? "80px" : "initial"};
        `}

  ${easeIn};

  ${({ active }) => active && ActiveLabel};
  ${Description} {
    color: ${({ active }) => (active ? "#fff" : undefined)};
  }
  ${Value} {
    color: ${({ active }) => (active ? "#fff" : undefined)};
  }
  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          background: #e3e3e3;
          box-shadow: none;

          span {
            color: #bcbcbc !important;
          }
        `
      : css``}
`;

const ImageWrapper = styled.span<LabelProps>`
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  img {
    width: 60px;
    height: 60px;
    border-radius: 50px;
    ${({ active }) => !active && BlackAndWhite}
  }
`;

const BlackAndWhite = css`
  filter: grayscale(100%);
  filter: gray;
`;

export default SelectionFilter;
